(() => {
  const selectors = {
    thumbnailSlider: ".product-thumbnail__slider",
    mainSlider: ".product-main__slider",
    swiperNext: ".swiper-button-next",
    swiperPrev: ".swiper-button-prev",
    discount: '.discount-code',
    rating: '.loox-rating-label',
    looxRatingParent: '.loox-rating',
    productFormArtwork: '#product-form-artwork',
    formPropertiesStyle: 'input[name="properties[Style]"]',
    swiperImages: '.swiper-slide img',
  }

  swiperInit();
  couponCopyListener();
  transformRating();
  looxMutationObserver();

  function couponCopyListener() {
    document.querySelector(selectors.discount)?.addEventListener('click', (e) => {
      if(e.target.closest(selectors.discount)) {
        navigator.clipboard.writeText(e.target.querySelector('em').innerText);
        e.target.innerHTML = e.target.closest(selectors.discount).dataset.copyText;
      }
    })
  };

  function swiperInit() {
    const thumbnailSlider = new Swiper(selectors.thumbnailSlider, {
      loop: true,
      spaceBetween: 9,
      slidesPerView: 3.7,
      freeMode: true,
      watchSlidesProgress: true,
      breakpoints: {
        768: {
          spaceBetween: 16,
          slidesPerView: 4.7,
        },
      }
    });
  
    const mainSlider = new Swiper(selectors.mainSlider, {
      loop: true,
      spaceBetween: 20,
      autoHeight: true,
      navigation: {
        nextEl: selectors.swiperNext,
        prevEl: selectors.swiperPrev,
      },
      thumbs: {
        swiper: thumbnailSlider,
      },
      breakpoints: {
        768: {
          spaceBetween: 10,
        },
      }
    });

    productFormImageUpdate(mainSlider);
  };

  function transformRating() {
    const ratingContainer = document.querySelector(selectors.rating);
    if (!ratingContainer) return;

    const text = ratingContainer.innerHTML;
    ratingContainer.innerHTML = `${text.trim().split('(')[1].slice(0, -1).split(",").join("")} Reviews`;
  };

  function looxMutationObserver() {
    const targetNode = document.querySelector(selectors.looxRatingParent);

    const config = {
      childList: true,
      subtree: true
    };

    const callback = function(mutationsList, observer) {
      for (let mutation of mutationsList) {
        if (mutation.type === 'childList') {
          targetNode.innerHTML.trim() == "" && transformRating();
          observer.disconnect();
        }
      }
    };

    const observer = new MutationObserver(callback);

    observer.observe(targetNode, config);
  };

  function productFormImageUpdate(mainSwiper) {
    const $form = document.querySelector(selectors.productFormArtwork);

    if (!$form) {
      return;
    }

    $form.querySelectorAll(selectors.formPropertiesStyle).forEach(($el) => {
      $el.addEventListener("change", () => {
        const swiperCarousel = document.querySelector(selectors.mainSlider);
        const swiperCarouselImages = swiperCarousel.querySelectorAll(selectors.swiperImages);
  
        swiperCarouselImages.forEach((image, index) => {
          const imageAltText = image.getAttribute('alt');
          if ($el.value === imageAltText) {
            mainSwiper.slideTo(index);
            return;
          }
        });
      });
    });
  }
})();
